module.exports = __webpack_public_path__ + "3057f438c6e53ae76b5a90dafd98de6e.png";